import { render } from "./Payrolls.vue?vue&type=template&id=0a35f9e5&scoped=true"
import script from "./Payrolls.vue?vue&type=script&lang=js"
export * from "./Payrolls.vue?vue&type=script&lang=js"

import "./Payrolls.vue?vue&type=style&index=0&id=0a35f9e5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0a35f9e5"

export default script